import { SvgIcon } from '../SvgIcon';
import clsx from 'clsx';
import * as React from 'react';

interface IProps {
	className?: string;
	fillColor?: string;
	height?: number;
	width?: number;
}

export const ShareIcon: React.FC<IProps> = props => {
	const { className, fillColor = 'currentColor', width = 24, height = 24 } = props;
	return (
		<SvgIcon className={clsx(className)} height={height} width={width} viewBox='0 0 14 14'>
			<path
				fill={fillColor}
				fillRule='evenodd'
				d='M9.5 9c-.812 0-1.529.396-1.986.998L4.952 8.974A2.52 2.52 0 0 0 5 8.5c0-.162-.018-.319-.048-.473l2.562-1.025A2.492 2.492 0 0 0 9.5 8C10.878 8 12 6.878 12 5.5S10.878 3 9.5 3A2.503 2.503 0 0 0 7 5.5c0 .03.008.059.009.089L4.228 6.701A2.488 2.488 0 0 0 2.5 6 2.503 2.503 0 0 0 0 8.5C0 9.878 1.122 11 2.5 11c.671 0 1.278-.27 1.728-.701l2.781 1.112c-.001.03-.009.059-.009.089C7 12.878 8.122 14 9.5 14s2.5-1.122 2.5-2.5S10.878 9 9.5 9Z'
				clipRule='evenodd'
			/>
		</SvgIcon>
	);
};
